import getTranslation from '../../utilities/getTranslation';

export const hasActiveSubscription = (allSubscriptions) => allSubscriptions.some((s) => s.active);

const groupHasOffer = (productGroups) =>
  productGroups
    .map((group) =>
      group.products
        .map((product) => product.informationKeys['pricing.offer.code'])
        .filter((offer) => offer && offer !== '')
        .some(Boolean)
    )
    .some(Boolean);

export const isCustomerEligibleForOffer = (hasActiveSubscription, isCustomerInactive) =>
  !hasActiveSubscription && !isCustomerInactive;

export const shouldShowOfferUsingDeprecatedBehaviour = (
  productGroups,
  hasActiveSubscription,
  isCustomerInactive
) =>
  groupHasOffer(productGroups) &&
  isCustomerEligibleForOffer(hasActiveSubscription, isCustomerInactive);

export const isSubscriptionEmpty = (subscription) => JSON.stringify(subscription) === '{}';

const getProductGroupPrice = (productGroup) => {
  return productGroup.products.length > 1
    ? getTranslation(productGroup.informationKeys, 'pricing.offer.title')
    : getTranslation(productGroup.products[0].informationKeys, 'pricing.offer.title');
};

export const hasPriceOffer = (productGroup) => {
  const productGroupPrice = getProductGroupPrice(productGroup);
  return productGroupPrice.includes('span');
};

export const getHost = (subscriptionData) =>
  typeof window !== 'undefined' &&
  (window.location.host.indexOf('storytel.com') > -1 ||
    window.location.host.indexOf('storytel.dev') > -1 ||
    window.location.host.indexOf('mofibo.com') > -1)
    ? ''
    : subscriptionData.countryIso === 'dk'
    ? 'https://mofibo.dk'
    : 'https://www.storytel.com';

export const getMyAccountHost = () => {
  let myAccountHost = '';
  const url = window.location.host;
  switch (url) {
    case 'www.storytel.com':
    case 'storytel.com':
      myAccountHost = 'https://account.storytel.com';
      break;
    case 'www.mofibo.com':
    case 'mofibo.com':
      myAccountHost = 'https://myaccount.mofibo.com';
      break;
  }
  return myAccountHost;
};

export const subscriptionStatus = (
  productId,
  currentUserSubscriptionId,
  currentSubscription,
  componentInformationKeys,
  upcomingSubscription
) => {
  let status = { class: 'ongoing ongoing-or-upcoming-plan', localisation: '' };
  if (currentUserSubscriptionId === productId && currentSubscription.active) {
    return (status = {
      ...status,
      localisation: getTranslation(componentInformationKeys, 'subscription.currentsubscription.v2'),
    });
  } else if (upcomingSubscription.metadataId === productId && !currentSubscription.active) {
    return (status = {
      ...status,
      localisation: getTranslation(
        componentInformationKeys,
        'subscription.upcomingsubscription.v2'
      ),
    });
  } else if (currentUserSubscriptionId === productId && !currentSubscription.active) {
    return (status = {
      class: 'ongoing ongoing-cancelled-plan',
      localisation: getTranslation(
        componentInformationKeys,
        'subscription.currentcancelledsubscription.v2'
      ),
    });
  }

  return (status = { class: '', localisation: '' });
};
